import { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import MobilePage from "routes/Mobile";
import styled from "styled-components";
import Footer from "./Footer";
import Header from "./Header";
import Loading from "./Loading";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const AppLayout = () => {
  const isPathCompany = window.location.pathname.includes("company");
  const isMobileAppLinks = window.location.pathname.includes(
    "mobile/app/links"
  );

  if (window.innerWidth < 800 && !isMobileAppLinks) {
    return <MobilePage />;
  }

  return (
    <MainContainer>
      <Helmet>
        <title>
          Ennea Solutions | Transforming Pharma Supply Chains Digitally
        </title>
      </Helmet>
      <Header />
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
      <Footer showBackground={isPathCompany} />
    </MainContainer>
  );
};

export default AppLayout;
